<template>
  <div class="flex main-container">
    <div class="unfoldIconClass" v-show="!collapsed" @click="() => (collapsed = true)"></div>
    <div class="foldIconClass" v-show="collapsed" @click="() => (collapsed = false)"></div>
    <a-layout id="components-layout-demo-custom-trigger">
      <a-layout-sider v-model="collapsed" :trigger="null" collapsible class="list">
        <a-menu class="menu-item" mode="inline" v-model="activeMenu">
          <a-menu-item v-for="item in filteredList" :key="item.value" @click.native="goTab(item)">
            <img class="itemIcon" :src="selectedValue == item.value ? item.selectedIcon : item.icon" :alt="item.name" />
            <span>{{ $t(item.name) }}</span>
          </a-menu-item>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-content>
          <div class="detailsBox">
            <router-view />
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import { hasPermission } from '@/utils/auth'
export default {
  data() {
    return {
      selectedValue: '',
      index: 0,
      data: {},
      list: [
        {
          name: 'project.workbench',
          path: 'workbench',
          value: 'workbench',
          key: '1',
          icon: require('@/assets/workbench/myWorkbenchIcon.png'),
          selectedIcon: require('@/assets/workbench/myWorkbenchActiveIcon.png'),
          authCode: 'web_workbench',
        },
        {
          icon: 'myTemplate',
          name: 'project.myTemplate',
          path: 'myTemplate',
          value: 'myTemplate',
          key: '2',
          icon: require('@/assets/workbench/myTemplateIcon.png'),
          selectedIcon: require('@/assets/workbench/myTemplatetActiveIcon.png'),
          authCode: 'web_my_template',
        },
        {
          icon: 'recycled',
          name: 'project.recycleBin',
          path: 'recycled',
          value: 'recycled',
          key: '5',
          icon: require('@/assets/workbench/recycledIcon.png'),
          selectedIcon: require('@/assets/workbench/recycledActiveIcon.png'),
          authCode: 'web_recycle_bin',
        },
      ],
      activeMenuIndex: 0,
      activeMenu: [], // 修改：初始化为空，后续根据权限与路由自动设置
      subActiveMenu: [],
      current: ['mail'],
      theme: 'light',
      collapsed: false,
    }
  },
  computed: {
    routePath() {
      return this.$route.name
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    authList() {
      return this.$store.getters.authList
    },
    filteredList() {
      return this.list.filter(item => hasPermission(item.authCode))
    },
  },
  watch: {
    $route: {
      handler() {
        this.ensureMenuInit()
      },
      immediate: true,
    },
    // 用户信息异步加载完成后，依据权限重算菜单与路由
    authList: {
      handler(val) {
        if (Array.isArray(val)) {
          this.ensureMenuInit()
        }
      },
      deep: false,
    },
  },
  created() {
    this.ensureMenuInit()
  },
  methods: {
    /**
     * 路由与权限同步菜单选中；无权限时回退到首个有权限项并替换路由
     */
    ensureMenuInit() {
      const currentName = this.$route.name || (this.$route.path.split('/')[2] || '')
      const currentItem = this.list.find(i => i.value === currentName)
      const allowed = currentItem ? hasPermission(currentItem.authCode) : false

      if (allowed) {
        this.activeMenu = [currentItem.value]
        this.selectedValue = currentItem.value
      } else {
        const fallback = this.filteredList[0]
        if (fallback) {
          this.activeMenu = [fallback.value]
          this.selectedValue = fallback.value
          // 路由与菜单不一致时，回退并保持一致
          if (currentItem?.path !== fallback.path) {
            this.$router.replace({ path: '/workbench/' + fallback.path })
          }
        } else {
          // 无任何权限项
          this.activeMenu = []
          this.selectedValue = ''
        }
      }
    },
    /**
     * 点击菜单项，更新选中并跳转
     */
    goTab(item) {
      this.selectedValue = item.value
      this.activeMenu = [item.value]
      this.$router.push({ path: '/workbench/' + item.path })
    },
  },
}
</script>

<style lang="less" scoped>
.main-container {
  width: 100%;
  margin-top: 60px;
  height: calc(100vh - 60px);
  display: flex;
  position: relative;
  .unfoldIconClass {
    width: 20px;
    height: 20px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('./../../assets/img/unfoldIcon.png');
    cursor: pointer;
    z-index: 999;
    position: absolute;
    left: 190px;
    top: 40px;
  }
  .foldIconClass {
    width: 20px;
    height: 20px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('./../../assets/img/foldIcon.png');
    cursor: pointer;
    z-index: 999;
    position: absolute;
    left: 70px;
    top: 40px;
  }
  .detailsBox {
    width: 100%;
    height: 100%;
    padding: 24px 30px;
    color: #fff;
  }
}
.itemIcon {
  width: 24px;
  height: 24px;
  margin-right: 25px;
}
.personal-list {
  width: 200px;
}
.list {
  width: 228px;
  height: calc(100vh - 60px);
  background: #232324;
  padding: 20px 0px;
}

.list-item {
  width: 200px;
  height: 50px;
  line-height: 50px;
  margin-bottom: 10px;
  background: #232324;
}
.list-item a {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}

/deep/ .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  color: #ffffff;
  background: linear-gradient(90deg, #353a54 0%, rgba(53, 58, 84, 0) 100%);
  border-radius: 8px 8px 8px 8px;
}

/deep/ .ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  border-right: 0px;
}

/deep/ .ant-menu-root.ant-menu-vertical,
.ant-menu-root.ant-menu-vertical-left,
.ant-menu-root.ant-menu-vertical-right,
.ant-menu-root.ant-menu-inline {
  background: #232324;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #ccc;
}

/deep/ .ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: 0px;
}

/deep/ .ant-layout {
  background-color: #17171a;
}
</style>
